import { forwardRef } from "react";
import { TextBox, Tooltip } from "@etframework/ui.components";
import { useTranslation } from "react-i18next";

export const TaskTypeNameTextBox = forwardRef(
  ({ name, change, ...rest }, ref) => {
    const { t } = useTranslation(["TaskTypes"]);

    return (
      <>
        <div className="d-flex">
          <span className="task-type-label me-1">
            {t("CreateTaskTypeModal.TaskTypeNameLabel")}
          </span>
          <Tooltip
            content={() => {
              return (
                <span>{t("CreateTaskTypeModal.TaskTypeNameTooltip")}</span>
              );
            }}
            openDelay={500}
            position="TopCenter"
            showTipPointer={false}
          >
            <i className={`fa-regular fa-circle-info icon`}></i>
          </Tooltip>
        </div>
        <TextBox
          ref={ref}
          name={name}
          id="task-type-txt-box"
          type="text"
          placeholder={t("CreateTaskTypeModal.TaskTypeNamePlaceholder")}
          showClearButton
          change={(e) => {
            ref.current.setShowError(false);
            change(e);
          }}
          {...rest}
        ></TextBox>
      </>
    );
  }
);
